// FunctionsTagApplier.jsx
//Applies tags to each unique Card locally in parent BootstrapStarterCard
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import './CSSTagApplierPerCard.css';
import './CSSTagApplierPerCardPopup.css';

const FunctionsTagApplier = ({
    row,
    toggleMenuForRow,
    hideMainMenu,
    isMenuOpenForRow,
    columns,
    rows,
    setRows,
    listItems
}) => {


    const countAppliedTagsLocalCard = (colId) => {
        const appliedTags = row[`column${colId}_selected`] || [];

        const countAppliedTagsLocalCardIconUpdate = () => {
            // Use scoped IDs based on row.id and colId
            const cardOverlayTextDiv = document.querySelector(`#itemSelectedTrueIconOverlayContainerText-${row.id}-${colId}`);
            const cardIconImg = document.querySelector(`#itemSelectedTrueIconOverlayContainerImg-${row.id}-${colId}`);

            if (cardOverlayTextDiv && cardIconImg) {
                const value = cardOverlayTextDiv.textContent.trim();
                if (value === "0" && cardIconImg.src.includes('tag-black-gold.svg')) {
                    cardIconImg.src = "/SVGicons/tag-black.svg";
                } else if (value !== "0" && cardIconImg.src.includes('tag-black.svg')) {
                    cardIconImg.src = "/SVGicons/tag-black-gold.svg";
                }
            }

            // Update all icons in tagApplierColumnTitleContainerTrueIconOverlayContainer
            const columnIconContainers = document.querySelectorAll('#tagApplierColumnTitleContainerTrueIconOverlayContainer');
            columnIconContainers.forEach(container => {
                const iconImg = container.querySelector('img');
                const textDiv = container.querySelector('.tagApplierColumnTitleContainerTrueIconOverlayContainerText');

                if (iconImg && textDiv) {
                    const value = textDiv.textContent.trim();
                    if (value === "0" && iconImg.src.includes('tag-black-gold.svg')) {
                        iconImg.src = "/SVGicons/tag-black.svg";
                    } else if (value !== "0" && iconImg.src.includes('tag-black.svg')) {
                        iconImg.src = "/SVGicons/tag-black-gold.svg";
                    }
                }
            });
        };

        setTimeout(countAppliedTagsLocalCardIconUpdate, 50);
        return appliedTags.length;
    };

    const countAvailableTagsLocalCard = (colId) => {
        const selected = row[`column${colId}_selected`] || [];
        const available = listItems.filter(item => !selected.includes(item.text));
        countAvailableTagsLocalCardIconUpdate(colId);
        return available.length;
    };

    const countAvailableTagsLocalCardIconUpdate = (colId) => {
        setTimeout(() => {
            const img = document.querySelector(`#availableTagsIconImg-${row.id}-${colId}`);
            const textDiv = document.querySelector(`#availableTagsText-${row.id}-${colId}`);

            if (img && textDiv) {
                const value = parseInt(textDiv.textContent.trim(), 10);
                if (value === 0 && img.src.includes('tag-black-gold.svg')) {
                    img.src = "/SVGicons/tag-black.svg";
                } else if (value > 0 && img.src.includes('tag-black.svg')) {
                    img.src = "/SVGicons/tag-black-gold.svg";
                }
            }
        }, 50);
    };



    return (

        <div id="appBodyCol3And4ContainerOuter" className="col-12 appBodyCol3And4ContainerOuter">
            <div id="appBodyCol3And4ContainerInner" className="appBodyCol3And4ContainerInner">
                {/* Desktop Tool Accessor */}
                <div id="appBodyCol3" className="col-12 gray appBodyCol3Container">
                    {/* THREE */}
                    <div id="tagApplierColumnTitleContainer" className="tagApplierColumnTitleContainer">
                        <div id="tagApplierColumnTitleContainerTitleBox" className="tagApplierColumnTitleContainerTitleBox">



                        </div>

                        {columns.map(col => (
                            <div
                                key={`tag-applier-icon-title-${col.id}`}
                                id="tagApplierColumnTitleContainerTrueIconOverlayContainer"
                                className="tagApplierColumnTitleContainerTrueIconOverlayContainer"
                                onClick={() => {
                                    toggleMenuForRow(row.id, 'tagApplier');
                                    hideMainMenu();
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src="/SVGicons/tag-black-gold.svg"
                                    alt=""
                                />
                                <div
                                    id="tagApplierColumnTitleContainerTrueIconOverlayContainerText"
                                    className="tagApplierColumnTitleContainerTrueIconOverlayContainerText"
                                >
                                    {countAppliedTagsLocalCard(col.id)}
                                </div>
                            </div>
                        ))}


                    </div>

                    <div id="tagApplierContainer" className="tagApplierContainer">
                        <Button
                            onClick={() => {
                                toggleMenuForRow(row.id, 'tagApplier');
                                hideMainMenu();
                            }}
                            id="buttonTagApplierIsAContainer"
                            className="btn-sm buttonTagApplierIsAContainer"
                        >

                            {/* Applied Tags Preview */}
                            {(() => {
                                const allSelectedTags = columns.flatMap(col => row[`column${col.id}_selected`] || []);
                                return (
                                    <div
                                        style={{ marginTop: '4px' }}
                                        className="appliedTagsDisplayContainer"
                                    >
                                        {allSelectedTags.length > 0 ? (
                                            <ul className="appliedTagsDisplayContainerList">
                                                {allSelectedTags.map((tag, idx) => (
                                                    <li
                                                        key={idx}
                                                        className="appliedTagsDisplayContainerListItems"
                                                    >
                                                        <p>{tag}</p>
                                                    </li>
                                                ))}
                                            </ul>) : (


                                            <div
                                                id="noTagsAppliedText"
                                                className="noTagsAppliedText"
                                            >
                                                <ul className="appliedTagsDisplayContainerListNone">
                                                    <li className="appliedTagsDisplayContainerListItemsNone"
                                                    >
                                                        <p>Apply a tag...</p>
                                                    </li>
                                                </ul>

                                            </div>
                                        )}
                                    </div>
                                );
                            })()}
                        </Button>

                        <div
                            id="tagApplier"
                            className={`tagApplier cardMenuColorToggle ${isMenuOpenForRow(row.id, 'tagApplier') ? '' : 'd-none'}`}
                        >
                            <div>
                                <Row>
                                    <Col className="d-flex justify-content-start tagApplierPopupHeaders">
                                        <p>Manage Tags for Card {row.id}</p>
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        <Button
                                            onClick={() => toggleMenuForRow(row.id, 'tagApplier')}
                                            id="closeOpenTagApplier"
                                            className="closeOpenTagApplier"
                                            aria-label="Close"
                                        >
                                            <img
                                                src="/SVGicons/X-white.svg"
                                                alt="Close"
                                                style={{ width: '12px', height: '12px' }}
                                            />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            {columns.map(col => (
                                <div
                                    id="tagApplierOld"
                                    key={`col-${col.id}-row-${row.id}`}
                                    style={{ marginBottom: '24px' }}
                                >
                                    <div id="itemSelectedTrue" className="itemSelectedTrue">
                                        <div className="itemSelectedTrueIconAndTitleContainer">
                                            <div className="itemSelectedTrueIcon">
                                                <div
                                                    id={`itemSelectedTrueIconOverlayContainer-${row.id}-${col.id}`}
                                                    className="itemSelectedTrueIconOverlayContainer"
                                                >
                                                    <img
                                                        id={`itemSelectedTrueIconOverlayContainerImg-${row.id}-${col.id}`}
                                                        src="/SVGicons/tag-black-gold.svg"
                                                        alt=""
                                                        style={{ width: '30px', height: '30px' }}
                                                    />
                                                    <div
                                                        id={`itemSelectedTrueIconOverlayContainerText-${row.id}-${col.id}`}
                                                        className="itemSelectedTrueIconOverlayContainerText"
                                                    >
                                                        {countAppliedTagsLocalCard(col.id)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="itemSelectedTrueTitle">
                                                Applied Tags
                                            </div>
                                        </div>

                                        {(row[`column${col.id}_selected`] || []).map((tag, idx) => (
                                            <div
                                                key={`selected-${idx}`}
                                                onClick={() => {
                                                    const selected = (row[`column${col.id}_selected`] || []).filter(t => t !== tag);
                                                    const updatedRows = rows.map(r =>
                                                        r.id === row.id ? { ...r, [`column${col.id}_selected`]: selected } : r
                                                    );
                                                    setRows(updatedRows);
                                                }}
                                                id={`itemSelectedTrueTags-${row.id}-${col.id}-${idx}`}
                                                className="itemSelectedTrueTags"
                                            >
                                                <Row id="itemSelectedTrueTagsTextAndIconBox" className="align-items-center">
                                                    <Col
                                                        id="itemSelectedTrueTagsText"
                                                        className="text-start itemSelectedFalseTagsText"
                                                        xs={10} // 10 out of 12 columns = ~83%
                                                    >
                                                        {tag}
                                                    </Col>
                                                    <Col
                                                        id="itemSelectedTrueTagsIcon"
                                                        xs={2} // 2 out of 12 columns = ~17%
                                                        className="d-flex justify-content-end align-items-center itemSelectedTrueAndFalseTagsIcon"

                                                    >
                                                        <img
                                                            src="/SVGicons/X-red.svg"
                                                            alt="Apply Tag"
                                                            style={{ width: '12px', height: '12px' }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>

                                    <div id="itemSelectedFalse" className="itemSelectedFalse">

                                        <div className="itemSelectedFalseIconAndTitleContainer">
                                            <div className="itemSelectedFalseIcon">
                                                <div className="itemSelectedFalseIconOverlayContainer">
                                                    <img
                                                        id={`availableTagsIconImg-${row.id}-${col.id}`}
                                                        src="/SVGicons/tag-black.svg"
                                                        alt="Available Tags Icon"
                                                        style={{ width: '30px', height: '30px' }}
                                                    />
                                                    <div
                                                        id={`availableTagsText-${row.id}-${col.id}`}
                                                        className="itemSelectedFalseIconOverlayContainerText"
                                                    >
                                                        {countAvailableTagsLocalCard(col.id)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="itemSelectedFalseTitle">
                                                Available Tags
                                            </div>
                                        </div>



                                        {listItems
                                            .filter(item => !(row[`column${col.id}_selected`] || []).includes(item.text))
                                            .map(item => (
                                                <div
                                                    key={`unselected-${item.id}`}
                                                    onClick={() => {
                                                        const selected = [...(row[`column${col.id}_selected`] || []), item.text];
                                                        const updatedRows = rows.map(r =>
                                                            r.id === row.id ? { ...r, [`column${col.id}_selected`]: selected } : r
                                                        );
                                                        setRows(updatedRows);
                                                    }}
                                                    className="itemSelectedFalseTags"
                                                >
                                                    <Row id="itemSelectedFalseTagsTextAndIconBox" className="align-items-center">
                                                        <Col
                                                            id="itemSelectedFalseTagsText"
                                                            className="text-start itemSelectedFalseTagsText"
                                                            xs={10} // 10 out of 12 columns = ~83%
                                                        >
                                                            {item.text}
                                                        </Col>
                                                        <Col
                                                            id="itemSelectedFalseTagsIcon"
                                                            xs={2} // 2 out of 12 columns = ~17%
                                                            className="d-flex justify-content-end align-items-center itemSelectedTrueAndFalseTagsIcon"

                                                        >
                                                            <img
                                                                src="/SVGicons/checkmark-green.svg"
                                                                alt="Remove Tag"
                                                                style={{ width: '12px', height: '12px' }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Mobile Tool Accessor */}
                <div id="appBodyCol4" className="col-md-12 gray appBodyCol4Container">
                    {/* FOUR */}
                    <div id="tagApplierColumnTitleContainer" className="tagApplierColumnTitleContainer">
                        <div id="tagApplierColumnTitleContainerTitleBox" className="tagApplierColumnTitleContainerTitleBox">



                        </div>



                    </div>

                </div>
            </div>

        </div>
    );
};

export default FunctionsTagApplier;
